import { render, staticRenderFns } from "./BaseCode.vue?vue&type=template&id=2c53de68&"
import script from "./BaseCode.vue?vue&type=script&lang=js&"
export * from "./BaseCode.vue?vue&type=script&lang=js&"
import style0 from "./BaseCode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports